import { TypeStoreDetail } from "@/lib/redux/features/store/type";
import { useIsDesktop } from "../app/useIsDesktop";

export const useShownQuickNavCategories = (store: TypeStoreDetail) => {
  const isDesktop = useIsDesktop()
  return !!isDesktop && store.shown_categories === true
}